export const padWithZeros = (n: number | string, width: number) => {
  const s = typeof n === 'number' ? String(n) : n;
  const trimmed = s.trim();

  const isNegative = trimmed.startsWith('-');
  const sign = isNegative ? '-' : '';

  const absStr = isNegative ? trimmed.slice(1) : trimmed;
  const padded = absStr.padStart(width, '0');

  return sign + padded;
};
